import React from "react"
import {GoldSpan, Heading, SubHeading, Wrapper} from "./styled"

const Title = () => (
  <Wrapper>
    <Heading>Fantastic Creatures</Heading>
    <SubHeading><GoldSpan>Hint:</GoldSpan> Sleepy Monster</SubHeading>
  </Wrapper>
)

export default Title